const mediation = () => import('@/pages/mediation/index.vue')
const details = () => import('@/pages/mediation/details.vue')
export default [
    {
      path: '/mediation',
      name: 'mediation',
      component:mediation,
      meta: {
        headerShow: true,
        footerShow: true,
        sidebarShow: false,
      }
    },
    {
        path: '/mediation/details/:id',
        name: 'mediationDetails',
        component:details,
        meta: {
          headerShow: true,
          footerShow: false,
          sidebarShow: false,
        }
      },
  ]


// WEBPACK FOOTER //
// ./src/router/modules/mediationRouter.js